<template>
  <section class="bar-settings">
    <BButton type="is-light" class="btn-close-css" rounded @click.prevent="$emit('close')"
      >CERRAR
      <img src="https://golstatsimages.blob.core.windows.net/todoelfut/close-blue-2.png" />
    </BButton>
    <BButton class="advanced" @click="onClickAvanzado">
      AVANZADO
      <img src="https://golstatsimages.blob.core.windows.net/todoelfut/sett.png" />
    </BButton>
    <button
      v-if="isLive"
      class="button is-rounded is-live-inactive"
      :class="{ 'is-live-active': showLiveData }"
      @click="switchShowLiveData"
    >
      <BIcon pack="mdi" icon="circle" size="is-small" type="is-green"> </BIcon>
      <span>LIVE</span>
    </button>
  </section>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import { btnLive, clickBtnAvanzado } from '@/utils/analytics';
export default {
  name: 'BarSettings',
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState('nextGeneral', ['showLiveData']),
    ...mapGetters('nextGeneral', ['showLive']),
    ...mapGetters('loginGeneral', ['getPremiumAccount', 'getIsGolstats']),
    ...mapGetters('nextGeneral', ['gameId', 'isLive']),
    ...mapGetters('general', ['getPreviewSectionAnalytics']),
  },
  watch: {},
  methods: {
    ...mapMutations('nextGeneral', ['toggleShowLiveData', 'toggleAdvanceFilter']),
    ...mapMutations(['SET_PREMIUM_MESSAGE_V2']),
    onClickAvanzado() {
      // if (this.getPremiumAccount) {
      clickBtnAvanzado(
        this.gameId,
        this.showLive,
        this.getPremiumAccount,
        this.getPreviewSectionAnalytics,
        this.getIsGolstats,
      );
      this.toggleAdvanceFilter();
      // } else {
      //   this.SET_PREMIUM_MESSAGE_V2(true);
      // }
    },
    switchShowLiveData() {
      btnLive(this.game_id, this.showLiveData, this.getPremiumAccount, this.getIsGolstats);

      if (this.getPremiumAccount) this.toggleShowLiveData();
      else this.SET_PREMIUM_MESSAGE_V2(true);
    },
  },

  async created() {},
};
</script>

<style lang="scss" scoped>
.btn-close-css {
  width: 142px;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  align-content: center;
  line-height: 40px;
  font-family: 'Avenir-Demi';
  border-radius: 25px;
  background-color: #f2f5fa;
  float: left;
  font-size: 16px;
  img {
    margin-top: 7px;
    margin-left: 5px;
    float: right;
    @media screen and (max-width: 540px) {
      width: 18px;
      margin-top: 11px;
    }
    @media screen and (max-width: 319px) {
      display: none;
    }
  }
  @media screen and (max-width: 540px) {
    width: 97px;
    height: 32px;
    border-radius: 17px;
    font-size: 11px;
  }
  @media screen and (max-width: 319px) {
    width: 70px;
  }
}
.is-live-inactive {
  color: white;
  height: 40px;
  font-family: 'Avenir-Demi';
  background-color: #d8d8d8;
  float: right;
  margin-right: 15px;
  @media screen and (max-width: 540px) {
    height: 32px;
    font-size: 11px;
  }
  @media screen and (max-width: 440px) {
    margin-right: 5px;
  }
  @media screen and (max-width: 319px) {
    margin-right: 1px;
  }
}
.is-live-inactive:hover {
  background-color: #b4abab;
}
.is-live-active {
  height: 40px;
  color: white;
  float: right;
  margin-right: 15px;
  font-family: 'Avenir-Demi';
  background-color: #132739;
  & > span.icon {
    color: #7ed321;
  }
  @media screen and (max-width: 540px) {
    height: 32px;
    font-size: 11px;
  }
  @media screen and (max-width: 440px) {
    margin-right: 5px;
  }
  @media screen and (max-width: 319px) {
    margin-right: 1px;
  }
}
.advanced {
  width: 172px;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  align-content: center;
  background-color: #7ed321 !important;
  color: white !important;
  float: right;
  line-height: 40px;
  border-radius: 25px;
  font-family: 'Avenir-Demi';
  font-size: 16px;
  img {
    margin-top: 7px;
    margin-left: 5px;
    float: right;
    @media screen and (max-width: 540px) {
      width: 18px;
      margin-top: 12px;
    }
  }
  @media screen and (max-width: 540px) {
    width: 129px;
    height: 32px;
    border-radius: 17px;
    font-size: 11px;
  }
  @media screen and (max-width: 440px) {
    width: 110px;
  }
}
.advanced:hover {
  background-color: #8ede3c !important;
  color: #076f07 !important;
}
</style>
